import React, { memo, ReactElement } from "react";
import { useTheme } from "styled-components";

const QRCodeSvg = (): ReactElement => {
    const theme = useTheme();

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.35129 3.93531e-07L4.8 7.51159e-07C5.24183 7.51159e-07 5.6 0.358173 5.6 0.800001C5.6 1.24183 5.24183 1.6 4.8 1.6H4.384C3.74354 1.6 3.31131 1.60062 2.97792 1.62786C2.65387 1.65434 2.49426 1.70192 2.38625 1.75695C2.1153 1.89501 1.89501 2.1153 1.75695 2.38625C1.70192 2.49426 1.65434 2.65387 1.62786 2.97792C1.60062 3.31131 1.6 3.74354 1.6 4.384V4.8C1.6 5.24183 1.24183 5.6 0.800001 5.6C0.358173 5.6 7.51159e-07 5.24183 7.51159e-07 4.8L3.93531e-07 4.35129C-1.05141e-05 3.75186 -1.95131e-05 3.25392 0.0331758 2.84763C0.0677361 2.42463 0.142228 2.03102 0.331341 1.65987C0.622796 1.08786 1.08786 0.622796 1.65987 0.331341C2.03102 0.142228 2.42463 0.0677361 2.84763 0.0331758C3.25392 -1.95131e-05 3.75186 -1.05141e-05 4.35129 3.93531e-07ZM14.6221 1.62786C14.2887 1.60062 13.8565 1.6 13.216 1.6H12.8C12.3582 1.6 12 1.24183 12 0.800001C12 0.358173 12.3582 7.51159e-07 12.8 7.51159e-07L13.2487 3.93531e-07C13.8481 -1.05141e-05 14.3461 -1.95131e-05 14.7524 0.0331758C15.1754 0.0677361 15.569 0.142228 15.9401 0.331341C16.5121 0.622796 16.9772 1.08786 17.2687 1.65987C17.4578 2.03102 17.5323 2.42463 17.5668 2.84763C17.6 3.25392 17.6 3.75187 17.6 4.35131V4.8C17.6 5.24183 17.2418 5.6 16.8 5.6C16.3582 5.6 16 5.24183 16 4.8V4.384C16 3.74354 15.9994 3.31131 15.9721 2.97792C15.9457 2.65387 15.8981 2.49426 15.8431 2.38625C15.705 2.1153 15.4847 1.89501 15.2137 1.75695C15.1057 1.70192 14.9461 1.65434 14.6221 1.62786ZM0.800001 12C1.24183 12 1.6 12.3582 1.6 12.8V13.216C1.6 13.8565 1.60062 14.2887 1.62786 14.6221C1.65434 14.9461 1.70192 15.1057 1.75695 15.2137C1.89501 15.4847 2.1153 15.705 2.38625 15.8431C2.49426 15.8981 2.65387 15.9457 2.97792 15.9721C3.31131 15.9994 3.74354 16 4.384 16H4.8C5.24183 16 5.6 16.3582 5.6 16.8C5.6 17.2418 5.24183 17.6 4.8 17.6H4.35131C3.75187 17.6 3.25392 17.6 2.84763 17.5668C2.42463 17.5323 2.03102 17.4578 1.65987 17.2687C1.08786 16.9772 0.622796 16.5121 0.331341 15.9401C0.142228 15.569 0.0677361 15.1754 0.0331758 14.7524C-1.95131e-05 14.3461 -1.05141e-05 13.8481 3.93531e-07 13.2487L7.51159e-07 12.8C7.51159e-07 12.3582 0.358173 12 0.800001 12ZM16.8 12C17.2418 12 17.6 12.3582 17.6 12.8V13.2487C17.6 13.8481 17.6 14.3461 17.5668 14.7524C17.5323 15.1754 17.4578 15.569 17.2687 15.9401C16.9772 16.5121 16.5121 16.9772 15.9401 17.2687C15.569 17.4578 15.1754 17.5323 14.7524 17.5668C14.3461 17.6 13.8481 17.6 13.2487 17.6H12.8C12.3582 17.6 12 17.2418 12 16.8C12 16.3582 12.3582 16 12.8 16H13.216C13.8565 16 14.2887 15.9994 14.6221 15.9721C14.9461 15.9457 15.1057 15.8981 15.2137 15.8431C15.4847 15.705 15.705 15.4847 15.8431 15.2137C15.8981 15.1057 15.9457 14.9461 15.9721 14.6221C15.9994 14.2887 16 13.8565 16 13.216V12.8C16 12.3582 16.3582 12 16.8 12Z"
                fill={theme.colors[theme.colorMode].background_inverse_Primary}
                fillOpacity="0.6"
            />
            <rect
                x="8.05005"
                y="3.79999"
                width="4"
                height="4"
                transform="rotate(90 8.05005 3.79999)"
                fill={theme.colors[theme.colorMode].background_inverse_Primary}
                fillOpacity="0.6"
            />
            <circle
                cx="11.55"
                cy="5.79999"
                r="2"
                fill={theme.colors[theme.colorMode].background_inverse_Primary}
                fillOpacity="0.6"
            />
            <rect
                x="8.05005"
                y="9.29999"
                width="4"
                height="4"
                transform="rotate(90 8.05005 9.29999)"
                fill={theme.colors[theme.colorMode].background_inverse_Primary}
                fillOpacity="0.6"
            />
            <rect
                x="13.45"
                y="9.29999"
                width="4"
                height="4"
                transform="rotate(90 13.45 9.29999)"
                fill={theme.colors[theme.colorMode].background_inverse_Primary}
                fillOpacity="0.6"
            />
        </svg>
    );
};

export default memo(QRCodeSvg);
